import styled from 'styled-components';
import { CredusText, CredusWrapper } from 'ui';
import { Divider } from 'antd';
import { TestReportTableProps } from '../report-models/report.interface';
import moment from 'moment';
import useInitiateProgressBar from '../hooks/useInitiateProgressBar';

const TestReportChart = ({ data }: TestReportTableProps) => {
  const { progressValue } = useInitiateProgressBar(data);
  return (
    <CredusWrapper display="flex" align="center" justify="center" gap="2.18rem">
      <ContainerWrapper>
        <CircularProgress progressStartValue={progressValue || 0}>
          <ProgressValue>
            <CredusText size="md" weight="bold" color="#181819" mb="0.01rem">
              {progressValue || 0}%
            </CredusText>
            <CredusText
              align="center"
              size="sm"
              weight="bold"
              color="rgba(24, 24, 25, 0.42)"
            >
              Fail
            </CredusText>
          </ProgressValue>
        </CircularProgress>
      </ContainerWrapper>
      <DividerWrap type="vertical" />
      <div>
        <CredusText size="sm" color="rgba(0, 0, 0, 0.53)" weight="regular">
          Total Question
        </CredusText>
        <CredusText size="sm" weight="medium">
          {data?.totalQuestion || 0}
        </CredusText>
        <DividerWrapper />
        <CredusText size="sm" color="rgba(0, 0, 0, 0.53)" weight="regular">
          Duration
        </CredusText>
        <CredusText size="sm" weight="medium">
          {data?.duration || 0}
        </CredusText>
        <DividerWrapper />
        <CredusText size="sm" color="rgba(0, 0, 0, 0.53)" weight="regular">
          Date | Time Spent
        </CredusText>
        <CredusText size="sm" weight="medium">
          {data?.dateTimeSpent
            ? moment(data?.dateTimeSpent).format('MMM Do YYYY')
            : 'NA'}{' '}
          |{' '}
          {data?.dateTimeSpent
            ? moment(data?.dateTimeSpent).format('LT')
            : 'NA'}
        </CredusText>
      </div>
    </CredusWrapper>
  );
};

export default TestReportChart;
const DividerWrap = styled(Divider)`
  height: 120px;
  margin: 0px;
  border: 1px solid rgba(224, 222, 247, 0.5);
`;
const DividerWrapper = styled(Divider)`
  width: 103px;
  margin-top: 7px;
  margin-bottom: 7px;
  border: 0.5px solid rgba(0, 0, 0, 0.15);
`;

const ContainerWrapper = styled.div``;
const CircularProgress = styled.div<{ progressStartValue: number }>`
  position: relative;
  height: 180px;
  width: 180px;
  border-radius: 50%;
  background: ${({ progressStartValue }) =>
    `conic-gradient(#fc391d ${progressStartValue * 3.6}deg, #ffc927 0deg)`};
  display: flex;
  justify-content: center;
  align-items: center;

  &::before {
    content: '';
    position: absolute;
    height: 115px;
    width: 115px;
    border-radius: 50%;
    background-color: #fff;
  }
`;
const ProgressValue = styled.div`
  position: relative;
  font-size: 40px;
  font-weight: 600;
  color: #7d2ae8;
`;
